// src/pages/PartsStepDesktop.jsx
import React from "react";
import { motion } from "framer-motion";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import SelectableCard from "./SelectableCard"; // default, but can be overridden by prop
import PartSuggestionForm from "./PartSuggestionForm";

const containerVariants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.1 } },
};
const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

export default function PartsStepDesktop({
  paginatedList,
  listLength,
  currentPage,
  setCurrentPage,
  onPartSelect,

  // Optional suggestion area (unused for favorites)
  onSuggest,
  showSuggest = true,

  // NEW: allow a custom card and extra props
  CardComponent = SelectableCard,
  cardPropsGetter, // (item) => ({ ...extraPropsForCard })
  setCurrentView
}) {
  
  return (
    <div className="parts-wrap">
      <button
        className="parts-nav left"
        onClick={() => setCurrentPage((p) => Math.max(0, p - 1))}
        disabled={currentPage === 0}
        aria-label="السابق"
      >
        <FiChevronLeft size={36} />
      </button>

      <motion.div className="parts-track" variants={containerVariants} initial="hidden" animate="show" dir="rtl">
        {paginatedList.map((item) => (
          <motion.div key={item.id} variants={cardVariants} className="parts-card-slot">
            <CardComponent
              item={item}
              onClick={onPartSelect}
              {...(cardPropsGetter?.(item) || {})}
              setCurrentView = {setCurrentView}
            />
          </motion.div>
        ))}
      </motion.div>

      {/* Suggestion area can be omitted for favorites by passing showSuggest={false} */}
      {showSuggest && typeof onSuggest === "function" && (
        <PartSuggestionForm onSubmit={onSuggest} />
      )}

      <button
        className="parts-nav right"
        onClick={() =>
          setCurrentPage((p) => (p < Math.ceil(listLength / 3) - 1 ? p + 1 : p))
        }
        disabled={currentPage >= Math.ceil(listLength / 3) - 1}
        aria-label="التالي"
      >
        <FiChevronRight size={36} />
      </button>
    </div>
  );
}
